

let localhost="http://127.0.0.1:8080/huapin"
let test="https://admin.zhuzhux.com/huapin"
let prod="https://bcqx.zhuzhux.com/huapin"
let qinbin="https://qinbin.zhuzhux.com/huapin"
let huarui="https://huarui.zhuzhux.com/huapin"
let prolocal="http://wojia.zhuzhux.com:8994/huapin"
let env = {

    BASE_API: huarui, // 开发环境


    
}
export default env


// WEBPACK FOOTER //
// ./src/services/env.js